import { Fragment, useContext } from "react";
import FooterWrapper from "components/shared/FooterWrapper";
import Link from "components/shared/Link";
import { Context } from "Context";
import appConfig from "config.json";
import Image from "components/shared/Image";

const mainClass = "syndicated-legal";
const { brands } = appConfig;

const Legal = ({ wrap = true }) => {
	const {
		config: {
			hideLegalFooterLinks,
			store,
			brand,
			openFooterLinksInNewTab,
			locale,
		},
		footerData: { legalFooter },
		legalFooterData,
	} = useContext(Context);
	const LegalWrapper = wrap ? FooterWrapper : Fragment;

	const renderLink = (link) => {
		const openLinkInNewTab =
			(store && brands[brand]?.openLinksInNewTabStores?.includes(store)) ||
			openFooterLinksInNewTab;
		if (link && openLinkInNewTab && (!link.target || link.target === "_self")) {
			link.target = "_blank";
		}
		return (
			<Link {...link} innerHtml openLinkContentInNewTab={openLinkInNewTab} />
		);
	};

	const renderModule = (module, key) => {
		const links = module?.webLinkList?.filter((link) => link);
		if (links?.length) {
			return (
				<ul
					key={key}
					className={`syndicated-legal__links syndicated-legal__links--${module.id}`}
				>
					{links.map((link, index) => (
						<li key={index}>{renderLink(link)}</li>
					))}
				</ul>
			);
		}
		if (module.descriptions?.[0]?.media) {
			return (
				<Image
					key={key}
					image={{
						url: module.descriptions[0].media[0].url,
						title: module.descriptions[0].media[0].alt,
					}}
					name={`legal`}
				/>
			);
		}
		return null;
	};

	return (
		<LegalWrapper>
			<div
				className={`${mainClass} ${mainClass}--${locale} ${mainClass}--${brand}`}
				style={{visibility: "hidden"}}
			>
				{!hideLegalFooterLinks &&
					(legalFooter || legalFooterData.legalFooter)?.modules?.map(
						(module, index) => renderModule(module, index)
					)}
				{(legalFooter || legalFooterData.legalFooter)?.descriptions?.map(
					(description, index) => (
						<p
							key={index}
							className={`${mainClass}__copyright-title`}
							dangerouslySetInnerHTML={{ __html: description.title }}
						/>
					)
				)}
			</div>
		</LegalWrapper>
	);
};

export default Legal;
